// Sums the six sequential top-level phases that define the full cycle duration.
// additionalReleaseTime is intentionally excluded — it overlaps with returnToPick
// (parallel movement), so including it would double-count that segment.
// Energy-saving fields (delayToEnergySave, timeWithEnergySavingOn/Off) are also
// excluded because they are already embedded within transferToPlace.
export var totalTime = function (speedData) {
    return speedData.vacuumOnBeforePick.value +
        speedData.blowOffOnBeforePick.value +
        speedData.timeToPartSecured.value +
        speedData.transferToPlace.value +
        speedData.releaseTimeToPlacePart.value +
        speedData.returnToPick.value;
};
